import Section from "../Section"

import styles from "./ContentBlock.module.scss"
import Link from "../Link"

const ContentBlock = ({ data }) => {
  const { teaser, headline, subline, text, links } = data
  return (
    <Section>
      <div className={styles.contentBlock}>
        {teaser && <div className={styles.teaser}>{teaser}</div>}
        {headline && <h2 className={styles.headline}>{headline}</h2>}
        {subline && <div className={styles.subline}>{subline}</div>}
        {text && (
          <div
            className={styles.text}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        )}
        {links?.length > 0 && (
          <div className={styles.links}>
            {links.map((link, i) => (
              <Link key={i} link={link} />
            ))}
          </div>
        )}
      </div>
    </Section>
  )
}

export default ContentBlock
